import { Percent } from '@kodiak-finance/sdk-core'

import { warningSeverity } from '../../utils/prices'
import { ErrorText } from './styleds'

export const formatPriceImpact = (priceImpact: Percent) => `${priceImpact.toFixed(1)}%`

/**
 * Formatted version of price impact text with warning colors
 */
export default function FormattedPriceImpact({ priceImpact }: { priceImpact?: Percent | null }) {
  return (
    <ErrorText fontWeight={500} fontSize={14} severity={warningSeverity(priceImpact ?? null)}>
      {priceImpact ? formatPriceImpact(priceImpact) : '-'}
    </ErrorText>
  )
}
